import { render, staticRenderFns } from "./wapTeacher.vue?vue&type=template&id=66c733f4&scoped=true"
import script from "./wapTeacher.vue?vue&type=script&lang=js"
export * from "./wapTeacher.vue?vue&type=script&lang=js"
import style0 from "./wapTeacher.vue?vue&type=style&index=0&id=66c733f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c733f4",
  null
  
)

export default component.exports